import { Component, Input, OnInit } from "@angular/core";
import { getRandomColor } from "@app/shared/common/utils";

@Component({
    selector: 'app-student-item',
    templateUrl: './student-item.component.html',
    styleUrls: ['./student-item.component.scss']
})
export class StudentItemComponent implements OnInit {
    @Input() student!: any;
    avatarColor = '';

    get firstCharacter() {
        return this.student.name[0];
    }

    constructor() { }

    ngOnInit(): void {
        this.avatarColor = getRandomColor();
    }
}